import { takeLatest } from 'redux-saga/effects';

import {
  PRODUCTS,
  PRODUCT_BRANDS,
  PRODUCT_RANGES,
} from 'actions/product.actions';
import {
  getProductBrandsSaga,
  getProductRangesSaga,
  getProductsSaga,
} from 'sagas/product.saga';
import { REQUEST } from 'services/api';

export function* getProductBrandsSagaWatcher(): Generator<any> {
  yield takeLatest(PRODUCT_BRANDS[REQUEST], getProductBrandsSaga);
}
export function* getProductRangesSagaWatcher(): Generator<any> {
  yield takeLatest(PRODUCT_RANGES[REQUEST], getProductRangesSaga);
}
export function* getProductSagaWatcher(): Generator<any> {
  yield takeLatest(PRODUCTS[REQUEST], getProductsSaga);
}
